import Exam from '@/views/team/exam'
import Team from '@/views/team/team'
import Chapter from '@/views/team/chapter'
import Details from '@/views/team/details'

export default [
    {
        path: '',
        component: Team,
        meta: {
            title: '做！就对了'
        }
    },
    {
        path: '/:code/team/exam',
        component: Exam,
        meta: {
            title: '超越自我'
        }
    },
    {
        path: '/:code/team/chapter',
        component: Chapter,
        meta: {
            title: '查漏补缺'
        }
    },
    {
        path: '/:code/team/chapter/:sectionCode',
        component: Details,
        meta: {
            title: '查漏补缺'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/team.js